import React from "react";

interface ShareButtonProps {
    title: string;
    text: string;
    url: string;
}

import icon from "@images/icon--share.svg";

const altText = "Share this article";

const ShareButton: React.FC<ShareButtonProps> = ({ title, text, url }) => {
    const handleShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title,
                    text,
                    url,
                });
                console.log("Successful share");
            } catch (error) {
                console.error("Error sharing:", error);
            }
        } else {
            console.log("Web Share API not supported");
            // Fallback behavior for browsers that do not support Web Share API
            // For example, copy to clipboard or open a modal with share links
        }
    };

    return (
        <button
            onClick={handleShare}
            title="Share"
            className="w-9 h-9 bg-black rounded-full flex items-center justify-center text-white"
            aria-label="Share this article"
        >
            {/* You can use an SVG icon here */}
            <img src={icon} alt={altText} title={altText}  className="max-w-[100%] max-h-9" />
        </button>
    );
};

export default ShareButton;
